import React from 'react';

const MasterTourLogo = ({ className = '', size = 20, width, height }) => {
  const finalWidth = width || size;
  const finalHeight = height || size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1296 1296"
      width={finalWidth}
      height={finalHeight}
      className={className}
      style={{ display: 'block' }}
      data-testid="master-tour-logo"
    >
      <path
        d="M847.076 399.993L713.147 128.624C685.615 72.8376 606.065 72.8376 578.533 128.624L444.604 399.993C440.96 407.377 433.915 412.495 425.766 413.679L126.293 457.195C64.729 466.141 40.1468 541.798 84.695 585.221L301.396 796.452C307.292 802.2 309.983 810.482 308.591 818.598L257.435 1116.86C246.919 1178.18 311.276 1224.93 366.34 1195.99L634.197 1055.16C641.486 1051.33 650.194 1051.33 657.482 1055.16L925.339 1195.99C980.404 1224.93 1044.76 1178.18 1034.24 1116.86L983.088 818.598C981.696 810.482 984.387 802.2 990.284 796.452L1206.98 585.221C1251.53 541.798 1226.95 466.141 1165.39 457.195L865.913 413.679C857.764 412.495 850.72 407.377 847.076 399.993Z"
        fill="#CC1F29"
        stroke="white"
        strokeWidth="50.0386"
        strokeLinejoin="round"
      />
      <rect x="544.324" y="358.555" width="207.36" height="522.72" rx="103.68" fill="white" />
      <rect x="684.539" y="1049.54" width="80.0618" height="126.982" transform="rotate(-180 684.539 1049.54)" fill="white" />
      <path
        d="M493.227 663.107L493.227 754.312V784.335C493.227 870.005 562.676 939.455 648.346 939.455C734.016 939.455 803.466 870.005 803.466 784.335V663.107"
        stroke="white"
        strokeWidth="50.0386"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
};

export default MasterTourLogo;